import { render, staticRenderFns } from "./UsageStatsTable.vue?vue&type=template&id=05c07eb4&"
import script from "./UsageStatsTable.vue?vue&type=script&lang=js&"
export * from "./UsageStatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports